import type { ThemePreset } from './types';
import { themeToCssVars } from './to-css-vars';

export function applyTheme(preset: ThemePreset) {
  if (typeof document === 'undefined') {
    return;
  }

  const root = document.documentElement;
  const vars = themeToCssVars(preset);

  for (const [name, value] of Object.entries(vars)) {
    root.style.setProperty(name, value);
  }

  root.dataset.theme = preset.name;
  root.classList.toggle('dark', preset.name === 'dark');
}
